import { Campaign } from './../../../core/models/campaigns';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user/user.service';
import { CONTRACT_TYPES, STATES } from 'src/app/shared/constants';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ContractWizardComponent } from 'src/app/shared/wizards/contract-wizard/contract-wizard.component';
import { ContractsService } from 'src/app/services/contracts/contracts.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import * as dayjs from 'dayjs';
import { jsPDF } from 'jspdf';
import { Date_range } from 'src/app/core/models/date-range';
import html2canvas from 'html2canvas';
import { environment } from 'src/environments/environment';
import { MENU } from 'src/app/layouts/sidebar/menu';
import { MenuItem } from 'src/app/layouts/sidebar/menu.model';
import { RingcentralService } from 'src/app/services/ringcentral/ringcentral.service';

@Component({
	selector: 'app-edit-client',
	templateUrl: './edit-client.component.html',
	styleUrls: ['./edit-client.component.scss'],
})
export class EditClientComponent implements OnInit {
	@Input() user_id: number;
	@Input() userRole: string = '';

	employeeUsers = [];
	contracts = [];
	userCampaigns = [];
	campaigns = [];
	logins = [];
	actions = [];
	states = STATES;
	contract_types = CONTRACT_TYPES;
	showDocuments = false;
	selectedContract = 0;
	selectedContractIndex: number = -1;
	selectedCampaign = 0;
	credit = 0;
	creaditAmount = '';
	discountLoading = false;
	editingEmail: boolean = false;
	ColumnMode = ColumnMode;
	dateRange_: Date_range = {
		dateStart: dayjs(new Date()).subtract(1, 'month'),
		dateEnd: dayjs(new Date()),
	};

	userInfo: FormGroup = new FormGroup({
		first_name: new FormControl(''),
		last_name: new FormControl(''),
		alias: new FormControl(''),
		primary_email: new FormControl(''),
		email2: new FormControl(''),
		email3: new FormControl(''),
		mobile_phone: new FormControl(''),
		phone_home: new FormControl(''),
		phone_work: new FormControl(''),
		phone_other: new FormControl(''),
		company_name: new FormControl(''),
		account_associated: new FormControl(''),
		address: new FormControl(''),
		city: new FormControl(''),
		state: new FormControl(''),
		zip_code: new FormControl(''),
		plan: new FormControl(''),
		isMain: new FormControl(false),
		isPremium: new FormControl(false),
		startupFeeAmount: new FormControl(''),
		ringcentral_ext: new FormControl(''),
		rc_ext_id: new FormControl(''),
	});

	userPermissions: any[] = [];
	loadingPermissions: boolean = false;
	selectedPermView: any = null;
	currentPermission: any = null;
	menuItems: MenuItem[] = MENU;

	// Columnas de la tab Permissions, generadas desde MENU: una vista nueva aparece sola.
	menuColumns: MenuItem[][] = this.buildMenuColumns(3);
	activeTabId: number = 1;

	get isInternalRole(): boolean {
		return ['SADM', 'ADM', 'CAL'].includes(this.userRole);
	}

	isDbReset: boolean = false;

	constructor(
		public activeModal: NgbActiveModal,
		private userSrv: UserService,
		public utils: UtilsService,
		private router: Router,
		private route: ActivatedRoute,
		private modalService: NgbModal,
		private contractSrv: ContractsService,
		private authSrv: AuthenticationService,
		private campaignSrv: CampaignService,
		private ringcentralSrv: RingcentralService,
	) {
		this.route.params.subscribe((params) => {
			this.user_id = +params['user_id'];
		});
	}

	ngOnInit() {
		this.getUserInfo();
		this.getEmployeeUsers();
		this.getSelectCampaigns();
	}

	private cleanNulls(obj: any): any {
		const cleaned: any = {};
		for (const key in obj) {
			cleaned[key] = obj[key] === null || obj[key] === 'null' || obj[key] === undefined ? '' : obj[key];
		}
		return cleaned;
	}

	getUserInfo() {
		this.userSrv.getUserById(this.user_id).subscribe((data: any) => {
			const body = this.cleanNulls(data.body);
			this.credit = body.credit;
			this.isDbReset = body.isDbReset == 1;
			this.userInfo.patchValue({
				first_name: body.first,
				last_name: body.last,
				alias: body.alias,
				primary_email: body.email1,
				email2: body.email2,
				email3: body.email3,
				mobile_phone: body.phone_mobile,
				phone_home: body.phone_home,
				phone_work: body.phone_work,
				phone_other: body.phone_other,
				company_name: body.company_name,
				account_associated: body.account_associated,
				address: body.address,
				city: body.city,
				state: body.state,
				zip_code: body.zip_code,
				plan: body.plan,
				isMain: body.isMain,
				isPremium: body.isPremium,
				startupFeeAmount: body.startupFeeAmount,
				ringcentral_ext: body.ringcentral_ext,
			});
		});
	}

	public getEmployeeUsers() {
		this.employeeUsers = [];
		this.userSrv.getActiveEmployees().subscribe((data: any) => {
			if (data.body) {
				if (data.body && data.body.length && !data.error) {
					this.employeeUsers = data.body;
				} else if (!data.success) {
					this.employeeUsers = [];
				}
			} else {
				this.employeeUsers = [];
			}
		});
	}

	getUserContracts() {
		this.userSrv.getClientContracts(this.user_id).subscribe((data: any) => {
			this.contracts = data.body.records;
		});
	}

	getContractTypeName(typeId: any): string {
		if (!typeId) return 'Not selected';
		const contractType = this.contract_types.find((ct) => ct.id == typeId);
		return contractType ? contractType.name : 'Unknown contract type';
	}

	openDocuments(contract_id, index) {
		// Toggle the selected row or select a new one
		if (this.selectedContractIndex === index && this.showDocuments) {
			// If clicking on the same row, toggle visibility
			this.showDocuments = false;
			this.selectedContractIndex = -1;
		} else {
			// If clicking on a new row or first time, show documents
			this.showDocuments = true;
			this.selectedContractIndex = index;
			this.selectedContract = contract_id;
		}
	}

	getUserCampaigns() {
		if (this.isInternalRole) {
			this.userSrv.getEmployeeCampaigns(this.user_id).subscribe((data: any) => {
				this.userCampaigns = data.body;
			});
		} else {
			const alias = this.userInfo.get('alias')?.value;
			this.userSrv.getUserCampaigns(alias).subscribe((data: any) => {
				this.userCampaigns = data.body;
			});
		}
	}

	onNavChange(event) {
		this.activeTabId = event.nextId;
		if (event.nextId == 2) {
			this.getUserContracts();
		} else if (event.nextId == 3) {
			this.getUserCampaigns();
		}
	}

	goToCampaign(campaign_id: number) {
		this.activeModal.close();
		this.router.navigate(['campaign-edit'], { queryParams: { id: campaign_id } });
	}

	getSelectCampaigns() {
		this.campaignSrv.getCampaignsForSelect().subscribe((data: any) => {
			this.campaigns = data.body;
		});
	}

	toggleMainUser(event) {
		//this.loading = true;
		this.userInfo.get('isMain').setValue(event.target.checked);
		const user = this.userInfo.value;

		if (event.target.checked) {
			this.userSrv.setMainAccount(this.user_id).subscribe(
				(data: any) => {
					Swal.fire('This user is now main user');
				},
				(error) => {
					this.userInfo.get('isMain').setValue(false);
					Swal.fire({
						title: 'Error',
						icon: 'error',
						text: 'Another user with the same alias is already a main user',
						confirmButtonText: 'Ok',
					});
				},
			);
		} else {
			this.userSrv.unsetMainAccount(this.user_id).subscribe((data: any) => {
				Swal.fire('This user is not main user anymore');
			});
		}
	}

	togglePremiumUser(event) {
		//this.loading = true;
		this.userInfo.get('isPremium').setValue(event.target.checked);
		const user = this.userInfo.value;

		if (event.target.checked) {
			this.userSrv.activatePremiumUser(this.user_id).subscribe((data: any) => {
				Swal.fire('Premium activated for this user');
			});
		} else {
			this.userSrv.deactivatePremiumUser(this.user_id).subscribe((data: any) => {
				Swal.fire('This user is not premium anymore');
			});
		}
	}

	sendLinkToCustomer() {
		const email1 = this.userInfo.get('primary_email')?.value;

		Swal.fire({
			title: 'Sending',
			text: 'Sending email reset password',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.userSrv.sendLinkCreationCustomer(`https://app.lmsleads.com/#/auth/signup/cover/${email1}`, email1).subscribe(
					(data: any) => {
						Swal.close();
						Swal.fire({
							title: 'Success',
							text: 'Link is sended correctly',
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
					},
					(error) => {
						Swal.fire({
							title: 'Error',
							icon: 'error',
							text: error,
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
					},
				);
			},
		});
	}

	toggleEmailEdit() {
		this.editingEmail = true;
	}

	private updatePrimaryEmail(): Promise<void> {
		const newEmail = this.userInfo.get('primary_email')?.value;

		return new Promise((resolve, reject) => {
			this.userSrv.updatePrimaryEmail({ user_id: this.user_id, email: newEmail }).subscribe(
				() => {
					this.editingEmail = false;
					resolve();
				},
				(error) => {
					Swal.fire({
						title: 'Error',
						icon: 'error',
						text: error,
						showCancelButton: false,
						confirmButtonText: 'Ok',
					});
					reject(error);
				},
			);
		});
	}
	openContractWizardModal() {
		const client_data = {
			id: this.user_id,
			alias: this.userInfo.get('alias')?.value,
		};

		const modalRef = this.modalService.open(ContractWizardComponent, {
			size: 'lg',
			centered: true,
			scrollable: true,
			backdrop: 'static',
		});

		modalRef.componentInstance.client_data = client_data;

		modalRef.result.then(
			(result) => {
				Swal.fire({
					icon: 'success',
					title: 'Contract created correctly',
					showCancelButton: false,
					confirmButtonText: 'Ok',
				}).then((res) => {
					this.getUserContracts();
				});
			},
			(reason) => {
				console.error('Modal dismissed with:', reason);
			},
		);
	}

	openModalLinkContracts(modal, campaign_id) {
		this.selectedCampaign = campaign_id;

		this.getUserContracts();
		this.modalService.open(modal, {
			size: 'lg',
			centered: true,
			scrollable: true,
			backdrop: 'static',
		});
	}

	linkContractCampaign(contractId: number) {
		const payload = {
			contract_id: contractId,
			campaign_id: this.selectedCampaign,
			user_id: this.user_id,
			alias: this.userInfo.get('alias')?.value,
		};

		this.contractSrv.linkContractToCampaign(payload).subscribe(
			(data: any) => {
				Swal.fire({
					icon: 'success',
					title: 'Contract linked successfully',
					showCancelButton: false,
					confirmButtonText: 'Ok',
				}).then((res) => {
					this.getUserCampaigns();
					this.modalService.dismissAll();
				});
			},
			(error) => {
				Swal.fire({
					icon: 'error',
					title: 'Error linking contract',
					text: error,
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
			},
		);
	}

	resetPassword() {
		const email = this.userInfo.get('primary_email')?.value;

		Swal.fire({
			title: 'Sending',
			text: 'Sending email reset password',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.authSrv.resetPassword(email).then(
					(data: any) => {
						Swal.close();
						Swal.fire({
							title: 'Success',
							text: 'Email sent correctly',
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
					},
					(error) => {
						Swal.fire({
							title: 'Error',
							icon: 'error',
							text: error,
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
					},
				);
			},
		});
	}

	testEmail() {
		const email = this.userInfo.get('primary_email')?.value;
		const name = this.userInfo.get('first_name')?.value + ' ' + this.userInfo.get('last_name')?.value;

		Swal.fire({
			title: 'Sending',
			text: 'Sending test email',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.userSrv.testUserEmail(email, name).subscribe(
					(data: any) => {
						Swal.close();
						Swal.fire({
							title: 'Success',
							text: 'Email sent correctly',
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
					},
					(error) => {
						Swal.fire({
							title: 'Error',
							icon: 'error',
							text: error,
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
					},
				);
			},
		});
	}

	updateClientUser() {
		if (this.userRole === 'CUS') {
			this.continueSave();
			return;
		}

		const email = this.userInfo.get('primary_email')?.value;

		if (!email) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'The email is mandatory to get the extension ID',
				showCancelButton: false,
				confirmButtonText: 'Ok',
			});
			return;
		}

		this.ringcentralSrv.getUserExtension({ email }).subscribe(
			(data: any) => {
				if (data?.body?.length) {
					this.userInfo.patchValue({
						ringcentral_ext: data.body[0].extensionNumber,
						rc_ext_id: data.body[0].id,
					});
				} else {
					Swal.fire({
						icon: 'warning',
						title: 'Warning',
						text: 'RingCentral extension ID could not be found. The rest of the information will still be saved.',
						showCancelButton: false,
						confirmButtonText: 'Ok',
					});
				}
				this.continueSave();
			},
			(error) => {
				Swal.fire({
					icon: 'warning',
					title: 'Warning',
					text: 'RingCentral extension ID could not be found. The rest of the information will still be saved.',
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
				this.continueSave();
			},
		);
	}

	private async continueSave() {
		if (this.editingEmail) {
			try {
				await this.updatePrimaryEmail();
			} catch {
				return;
			}
		}
		this.saveClientUser();
	}
	private saveClientUser() {
		const user = this.userInfo.value;
		delete user.primary_email;
		user.id = this.user_id;
		this.userSrv.updateClientUser(user).subscribe(
			(data: any) => {
				Swal.fire({
					icon: 'success',
					title: 'User updated successfully',
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
			},
			(error) => {
				Swal.fire({
					icon: 'error',
					title: 'Error updating user',
					text: error,
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
			},
		);
	}
	openDiscountModal(discountModal: any) {
		this.modalService.open(discountModal, {
			size: 'lg',
			centered: true,
			scrollable: true,
			backdrop: 'static',
		});
	}

	changeDiscount(type: string) {
		this.discountLoading = true;
		const payload = {
			user_id: this.user_id,
			credit_amount: this.creaditAmount,
			type: type,
		};

		this.userSrv.changeDiscount(payload).subscribe(
			(data: any) => {
				Swal.fire({
					icon: 'success',
					title: 'Discount changed successfully',
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
				this.discountLoading = false;
				this.getUserInfo();
				this.creaditAmount = '';
			},
			(error) => {
				Swal.fire({
					icon: 'error',
					title: 'Error changing discount',
					text: error,
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
				this.discountLoading = false;
			},
		);
	}

	setAlias(event) {
		this.userInfo.get('alias')?.setValue(event.alias);
	}

	dateSelected() {
		this.getLogins();
	}

	getLogins() {
		const start_date = this.dateRange_.dateStart.format('YYYY-MM-DD');
		const end_date = this.dateRange_.dateEnd.format('YYYY-MM-DD');

		this.userSrv.getUserLogins(this.user_id, start_date, end_date).subscribe(
			(data: any) => {
				this.logins = data.body;
			},
			(error) => {
				Swal.fire({
					icon: 'error',
					title: 'Error fetching user logins',
					text: error,
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
			},
		);
	}

	getUserActions() {
		const start_date = this.dateRange_.dateStart.format('YYYY-MM-DD');
		const end_date = this.dateRange_.dateEnd.format('YYYY-MM-DD');

		this.userSrv.getUserActions(this.user_id, start_date, end_date).subscribe(
			(data: any) => {
				this.actions = data.body;
			},
			(error) => {
				Swal.fire({
					icon: 'error',
					title: 'Error fetching user actions',
					text: error,
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
			},
		);
	}

	async getLoginHistoryImageUrl(): Promise<string> {
		const element = document.getElementById('loginHistoryTable');
		if (!element) {
			throw new Error('Element with id "loginHistoryTable" not found');
		}
		const canvas = await html2canvas(element);
		return canvas.toDataURL('image/png');
	}

	async exportLoginsToPDF() {
		this.utils.generarPDFConTabla(
			this.logins,
			['Login Time', 'IpV4', 'Country', 'Region', 'City', 'Zip', 'Latitude', 'Longitude', 'IpV6'],
			'Login History',
			{
				user: `${this.userInfo.get('first_name')?.value || ''} ${this.userInfo.get('last_name')?.value || ''}`,
				company: this.userInfo.get('company_name')?.value || '',
			},
			`${this.userInfo.get('first_name')?.value || ''}_${this.userInfo.get('last_name')?.value || ''}_login_history.pdf`,
			['signin_time', 'ip', 'country', 'region', 'city', 'zip', 'latitude', 'longitude', 'ipv6'],
		);
	}

	async exportActionsToPDF() {
		this.utils.generarPDFConTabla(
			this.actions,
			['Action Description', 'Date and time', 'IpV4', 'IpV6'],
			'Actions History',
			{
				user: `${this.userInfo.get('first_name')?.value || ''} ${this.userInfo.get('last_name')?.value || ''}`,
				company: this.userInfo.get('company_name')?.value || '',
			},
			`${this.userInfo.get('first_name')?.value || ''}_${this.userInfo.get('last_name')?.value || ''}_actions_history.pdf`,
			['action_description', 'date_time', 'ipv4', 'ipv6'],
		);
	}

	getUserInfoObject() {
		return {
			name: `${this.userInfo.get('first_name')?.value || ''} ${this.userInfo.get('last_name')?.value || ''}`,
			company_name: this.userInfo.get('company_name')?.value || '',
		};
	}

	getUserPermissions() {
		this.loadingPermissions = true;
		this.userSrv.getPermissions(this.user_id).subscribe((data: any) => {
			this.userPermissions = data.body || [];
			this.loadingPermissions = false;
		});
	}

	togglePermission(item: any, event: any) {
		const isActive = event.target.checked ? 1 : 0;
		const payload = {
			user_id: this.user_id,
			view_id: item.id,
			isActive: isActive,
		};
		this.userSrv.assignViewToUser(payload).subscribe(
			(data: any) => {
				// actualizar en userPermissions
				const perm = this.userPermissions.find((p) => p.view_id == item.id);
				if (perm) {
					perm.isActive = isActive;
				} else {
					this.userPermissions.push({ view_id: item.id, isActive: isActive });
				}
				Swal.fire({
					toast: true,
					position: 'top-end',
					icon: 'success',
					title: isActive ? 'Permission enabled' : 'Permission disabled',
					showConfirmButton: false,
					timer: 1500,
				});
			},
			(error) => {
				event.target.checked = !event.target.checked;
				Swal.fire({ title: 'Error', icon: 'error', text: 'Something went wrong', confirmButtonText: 'Ok' });
			},
		);
	}

	getPermission(view_id: number) {
		return this.userPermissions.find((p) => p.view_id == view_id) || { view_id, isActive: 0 };
	}

	// Reparte los elementos del menú en columnas de altura similar, respetando su orden.
	// Un elemento con subItems cuenta como su encabezado más una fila por hijo.
	private buildMenuColumns(count: number): MenuItem[][] {
		const items = this.menuItems.filter((item) => !item.isTitle && !item.isLayout);
		const weight = (item: MenuItem) => 1 + (item.subItems?.length || 0);
		const target = items.reduce((total, item) => total + weight(item), 0) / count;

		const columns: MenuItem[][] = Array.from({ length: count }, () => []);
		let current = 0;
		let filled = 0;
		for (const item of items) {
			if (columns[current].length && filled + weight(item) > target && current < count - 1) {
				current++;
				filled = 0;
			}
			columns[current].push(item);
			filled += weight(item);
		}
		return columns;
	}

	toggleDbReset(event: any) {
		const isDbReset = event.target.checked ? 1 : 0;
		const payload = { user_id: this.user_id, isDbReset: isDbReset };

		this.userSrv.updateDbReset(payload).subscribe(
			(data: any) => {
				this.isDbReset = isDbReset === 1;
				Swal.fire({
					toast: true,
					position: 'top-end',
					icon: 'success',
					title: isDbReset ? 'DB Reset enabled' : 'DB Reset disabled',
					showConfirmButton: false,
					timer: 1500,
				});
			},
			(error) => {
				event.target.checked = !event.target.checked;
				Swal.fire({ title: 'Error', icon: 'error', text: 'Something went wrong', confirmButtonText: 'Ok' });
			},
		);
	}
}
